import { Fragment, useEffect, useMemo, useRef } from "react";
import "./subject_collection_view.scss";
import images from "../../../../../../utilities/images/images";
import { backGroundColorFromBackend } from "../../../../../../custom_utilities/custom_useful_functions";
import {
  useDashboardSubjectListQuery,
  useDashboardUserProfileQuery,
} from "../../../../../../components/StudyDashboard/hooks/useStudyDashboardQueries";
//slick-carousel
import Slider from "react-slick";
//Redux
import { connect } from "react-redux";
import userActivityActions from "../../../../../../redux/user_activity/action";

export const SUBJECT_SCREEN_OLD_PATH = "/subject_component";
export const SUBJECT_SCREEN_NEW_PATH = "/dashboard/student-learning";

const EMPTY_SUBJECT_VIEW = {
  isCategorized: false,
  categories: [],
  subjects: [],
};

const SubjectCollectionView = (props) => {
  let {
    history,
    userPreference,
    setSubjectData,
    setCategoryData,
    setIsCategorizedSub,
  } = props;
  let { courseDetails, classDetails, targetDetails } = userPreference;
  const courseId = courseDetails?.[0]?.course_id;
  const classId = classDetails?.class_id;
  const targetId = targetDetails?.[0]?.target_id;
  const profileQuery = useDashboardUserProfileQuery();
  const subjectQuery = useDashboardSubjectListQuery();
  const profile = profileQuery.data;
  const isCategorized = Number(profile?.is_categorized_sub) === 1;
  const categories = Array.isArray(profile?.category) ? profile.category : [];
  const subjects = subjectQuery.data ?? [];
  const syncedKeyRef = useRef("");

  const subjectView = useMemo(() => {
    if (!profile) return EMPTY_SUBJECT_VIEW;
    if (isCategorized) {
      return { isCategorized: true, categories, subjects: [] };
    }
    if (!subjectQuery.isSuccess && !subjects.length) return EMPTY_SUBJECT_VIEW;
    return { isCategorized: false, categories: [], subjects };
  }, [categories, isCategorized, profile, subjectQuery.isSuccess, subjects]);

  const categorySignature = isCategorized
    ? categories.map((category) => category?.id ?? category?.name ?? "").join(",")
    : subjectQuery.isSuccess
      ? "subjects"
      : "";

  useEffect(() => {
    if (!profile || !categorySignature) return;
    const syncKey = `${targetId ?? ""}:${courseId ?? ""}:${classId ?? ""}:${
      isCategorized ? "1" : "0"
    }:${categorySignature}`;
    if (syncedKeyRef.current === syncKey) return;
    syncedKeyRef.current = syncKey;

    if (isCategorized) {
      setCategoryData({ category: categories });
      setIsCategorizedSub({ is_categorized_sub: 1 });
      return;
    }

    setCategoryData({ category: [] });
    setIsCategorizedSub({ is_categorized_sub: 0 });
  }, [
    categories,
    categorySignature,
    classId,
    courseId,
    isCategorized,
    profile,
    setCategoryData,
    setIsCategorizedSub,
    targetId,
  ]);

  const renderSubjectImage = (icon) => {
    if (icon) {
      return <img src={icon} alt="" />;
    } else {
      return <img src={images.user_dashboard_5} alt="" />;
    }
  };

  const navigateToSubjectScreen = (element, screenVersion = "new") => {
    const pathname =
      screenVersion === "new" ? SUBJECT_SCREEN_NEW_PATH : SUBJECT_SCREEN_OLD_PATH;

    if (subjectView.isCategorized) {
      props.setSelectedCategory(element.id);

      setSubjectData({
        categoryId: element.id,
        subjectId: element.subject?.[0]?.sub_id || "",
        subjectName: element.subject?.[0]?.sub_name || "",
        subjectIcon: element.subject?.[0]?.icon || "",
        subjects: element.subject || [],
        categoryName: element.name,
      });

      history.push({
        pathname,
        state: {
          categoryId: element.id,
          screenVersion,
          returnTo: history?.location?.pathname || "/dashboard",
        },
      });
      return;
    }

    setSubjectData({
      subjectId: element.sub_id,
      subjectName: element.sub_name,
      subjectIcon: element.icon,
    });

    props.setSelectedCategory("");

    history.push({
      pathname,
      state: {
        screenVersion,
        returnTo: history?.location?.pathname || "/dashboard",
      },
    });
  };

  const handleRedirect = (type, element) => {
    switch (type.toLowerCase()) {
      case "all":
        history.push(SUBJECT_SCREEN_OLD_PATH);
        break;
      case "subject":
        navigateToSubjectScreen(element, "new");
        break;
      default:
        break;
    }
  };

  const settings = {
    dots: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          // dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          autoplay: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <Fragment>
      <div className="subjectCollectionView_wrapper">
        <div className="subjectCollectionView_inner_wrapper">
          <div className="container">
            <div className="subject_collection">
              <div className="subject_collection_desktop">
                <Slider {...settings}>
                  {subjectView.isCategorized
                    ? subjectView.categories.map((element, index) => (
                        <div
                          className="home_page_single_subject_box"
                          key={element?.sub_id}
                        >
                          <div
                            className="home_page_single_subject"
                            onClick={() => handleRedirect("subject", element)}
                            style={backGroundColorFromBackend(
                              element.color_code
                            )}
                          >
                            <div className="home_page_image_wrapper">
                              {renderSubjectImage(element?.icon)}
                            </div>
                            <div className="home_page_text_content_wrapper">
                              <p className="home_page_text_content">
                                {element?.name}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))
                    : subjectView.subjects.length > 0 &&
                      subjectView.subjects.map((subject, index) => (
                        <div
                          className="home_page_single_subject_box"
                          key={subject?.sub_id}
                        >
                          <div
                            className="home_page_single_subject"
                            onClick={() => handleRedirect("subject", subject)}
                            style={backGroundColorFromBackend(
                              subject.color_code
                            )}
                          >
                            <div className="home_page_image_wrapper">
                              {renderSubjectImage(subject?.icon)}
                            </div>
                            <div className="home_page_text_content_wrapper">
                              <p className="home_page_text_content">
                                {subject?.sub_name}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userPreference: state.userPreference,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSubjectData: (payload) => {
      dispatch(userActivityActions.setSubjectData(payload));
    },
    setSelectedCategory: (payload) => {
      dispatch(userActivityActions.setSelectedCategory(payload));
    },
    setCategoryData: (payload) => {
      dispatch(userActivityActions.setCategoryData(payload));
    },
    setIsCategorizedSub: (payload) => {
      dispatch(userActivityActions.setIsCategorizedSub(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubjectCollectionView);
